import { useEffect, useRef, useState } from 'react'
import type { DecodedImage, DetectionRegion, ExportOptions } from '../types'
import { renderRedactedCanvas } from '../core/redaction'

interface Props {
  decoded: DecodedImage
  regions: DetectionRegion[]
  options: ExportOptions
}

export function ComparisonPreview({ decoded, regions, options }: Props) {
  const canvasRef = useRef<HTMLCanvasElement>(null)
  const [position, setPosition] = useState(50)

  useEffect(() => {
    const canvas = canvasRef.current
    if (!canvas) return
    const scale = Math.min(1, 1500 / Math.max(decoded.width, decoded.height))
    const width = Math.max(1, Math.round(decoded.width * scale))
    const height = Math.max(1, Math.round(decoded.height * scale))
    canvas.width = width
    canvas.height = height
    const original = document.createElement('canvas')
    original.width = width
    original.height = height
    original.getContext('2d')?.drawImage(decoded.drawable, 0, 0, width, height)
    const scaledRegions = regions.map((region) => ({
      ...region,
      rect: {
        x: region.rect.x * scale,
        y: region.rect.y * scale,
        width: region.rect.width * scale,
        height: region.rect.height * scale,
      },
    }))
    const redacted = renderRedactedCanvas(original, width, height, scaledRegions, options)
    const ctx = canvas.getContext('2d')
    if (!ctx) return
    ctx.clearRect(0, 0, width, height)
    ctx.drawImage(original, 0, 0)
    ctx.save()
    ctx.beginPath()
    ctx.rect(0, 0, width * (position / 100), height)
    ctx.clip()
    ctx.drawImage(redacted, 0, 0)
    ctx.restore()
    ctx.strokeStyle = '#0a84ff'
    ctx.lineWidth = 4
    ctx.beginPath()
    ctx.moveTo(width * (position / 100), 0)
    ctx.lineTo(width * (position / 100), height)
    ctx.stroke()
  }, [decoded, options, position, regions])

  return (
    <div className="compare-block">
      <div className="compare-labels"><span>加工後</span><span>加工前</span></div>
      <canvas ref={canvasRef} className="compare-canvas" />
      <label className="compare-slider">
        <span className="sr-only">加工前後の比較位置</span>
        <input type="range" min="0" max="100" value={position} onChange={(event) => setPosition(Number(event.target.value))} />
      </label>
    </div>
  )
}
